export default __webpack_public_path__ + "static/media/510.3bf0a88b.png";